import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-declined',
  templateUrl: './fh-svg-declined.component.html',
  styleUrl: './fh-svg-declined.component.scss'
})
export class FhSvgDeclinedComponent {
  @Input() color: string = '';
}
